import * as React from "react";

function ClientReports({color="var(--color-blue-500)",props}) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M19 19H8c-3.3 0-4.95 0-5.975-1.025C1 16.95 1 15.3 1 12V1"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
      <path
        d="M3 18c.44-3.156 2.676-11.236 5.428-11.236 1.902 0 2.395 3.871 4.258 3.871C15.893 10.635 15.428 2 19 2"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ClientReports;
